import PublicLayout from '../../containers/PublicLayout'
import { Navigate, useSearchParams } from 'react-router-dom'
import PaymentSuccessCard from '../../components/Payment/PaymentSuccessCard'

const PaymentSuccess = () => {
  const [params] = useSearchParams()
  const sessionId = params.get('session_id')
  if (!sessionId) {
    return <Navigate to='/' />
  }

  return (
    <PublicLayout>
      <PaymentSuccessCard />
    </PublicLayout>
  )
}

export default PaymentSuccess
